import _rubyMarkup from "../functions/quill/rubyMarkup.js";
import _stripTags from "../functions/quill/stripTags.js";
import _getLongestLine from "../functions/utility/getLongestLine.js";
import _vttFunc from "../functions/profiles/webVtt.js";
import _flexbox from "../dict/flexbox.js";
import _eol from "eol";
import _convertToPlainTextCustom from "../functions/quill/convertToPlainTextCustom.js";
import _convertToPlainText from "../functions/quill/convertToPlainText.js";
import _convertToHtml from "../functions/quill/convertToHtml.js";
import _getFormatOptions from "../functions/helpers/getFormatOptions.js";
import _removeInvalidEvents from "../functions/eventGroups/removeInvalidEvents.js";
import _tcLib from "../lib/timecode.js";
import _Event from "../classes/event.js";
const Event = _Event;
const tcLib = _tcLib;
const removeInvalidEvents = _removeInvalidEvents;
const getFormatOptions = _getFormatOptions;
const convertToHtml = _convertToHtml;
const convertToPlainText = _convertToPlainText;
const convertToPlainTextCustom = _convertToPlainTextCustom;
const eol = _eol;
const flexbox = _flexbox;
const vttFunc = _vttFunc;
const getLongestLine = _getLongestLine;
const stripTags = _stripTags;
const rubyMarkup = _rubyMarkup;
export default {
  decode: function (input, options) {
    let events = [];
    let subtitleBlocks = input.split("\n\n");
    let popOnPlacementFlag = false;
    const displayWidth = options?.window?.width || 32;
    const displayHeight = options?.window?.height || 15;
    const fullDisplayHeight = displayHeight + options.window.yPadding / 100 * displayHeight * 2;
    const fullDisplayWidth = displayWidth + options.window.xPadding / 100 * displayWidth * 2;
    subtitleBlocks.forEach(subtitleBlock => {
      let tcFlag = false,
        ccEvent = new Event();
      let blockLines = subtitleBlock.split("\n").filter(blockLine => {
        return blockLine.trim();
      });
      if (blockLines.length > 1) {
        blockLines.forEach(blockLine => {
          if (!tcFlag && blockLine.split(" --> ").length > 1) {
            tcFlag = true;
            popOnPlacementFlag = false;
            let pattern = /(\d{2}:\d{2}),(\d{3})/g;
            blockLine = blockLine.replace(pattern, "$1.$2");
            let lineInfo = blockLine.split(/ |,/);
            let tcIn = "00:" + lineInfo[0];
            let tcOut = "00:" + lineInfo[2];
            ccEvent.start = tcLib.tcMsToSec(tcIn.substring(tcIn.length - 12, tcIn.length), options.frameRate, options.dropFrame);
            ccEvent.end = tcLib.tcMsToSec(tcOut.substring(tcOut.length - 12, tcOut.length), options.frameRate, options.dropFrame);

            /* Check to see if the last event has the same timecode as the current event. If so... copy the text from the last event to the current event and remove it from the events list */
            if (events.length > 0 && (ccEvent.start === events[events.length - 1].start || ccEvent.end === events[events.length - 1].end)) {
              ccEvent.text = events[events.length - 1].text;
              popOnPlacementFlag = true;
              events.pop();
            }

            /* Check for extra metadata */
            let alignFlag = false,
              positionFlag = false,
              lineFlag = false;
            if (lineInfo.length > 3 && popOnPlacementFlag === false) {
              const xPadding = options?.window?.xPadding || 0; // percentage
              const yPadding = options?.window?.yPadding || 0; // percentage

              lineInfo.forEach(info => {
                if (/vertical:/g.test(info)) {
                  const verticalMode = info.split(":")[1].replace(",", "");
                  if (verticalMode === "rl" || verticalMode === "lr") {
                    ccEvent.writingMode = "tbrl";
                  }
                } else if (/align:/g.test(info)) {
                  alignFlag = true;
                  // Handle align attribute - sets text alignment within cue box
                  let alignmentMetadata = info.split(":")[1].replace(",", "");
                  ccEvent.alignment = flexbox.alignmentNormalize[alignmentMetadata] || "center";
                  // Don't override xPos from position attribute if it's already set
                  if (ccEvent.xPos === undefined || !positionFlag) {
                    ccEvent.xPos = flexbox.positionNormalize[alignmentMetadata] || "center";
                  }
                } else if (/position:/g.test(info)) {
                  positionFlag = true;
                  // Handle position attribute - horizontal position of cue box (percentage)
                  let positionMetadata = info.split(":")[1].split(",")[0].replace(/%|,/gim, "");
                  if (!isNaN(parseFloat(positionMetadata))) {
                    let pos = parseFloat(positionMetadata);
                    let xPosNumber = Math.round(fullDisplayWidth * (pos / 100));

                    // Clamp to valid range
                    if (xPosNumber <= fullDisplayWidth * (xPadding / 100)) {
                      ccEvent.xPos = "start";
                    } else if (xPosNumber >= fullDisplayWidth - fullDisplayWidth * (xPadding / 100)) {
                      ccEvent.xPos = "end";
                    } else if (pos > 40 && pos < 60) {
                      ccEvent.xPos = "center";
                    } else {
                      // Convert percentage to character position on display
                      ccEvent.xPos = xPosNumber - options.window.xPadding / 100 * fullDisplayWidth;
                    }
                  }
                } else if (/line:/g.test(info)) {
                  lineFlag = true;
                  // Handle line attribute - vertical position of cue box
                  // WebVTT uses 19 lines (1-19) from top to bottom
                  // Each line is ~5.26% of screen height (100% / 19 lines)
                  let vPosition = info.split(":")[1].replace(/,/gim, "");
                  // console.log("VPosition Raw: " + vPosition);									
                  // Check if it's a percentage value
                  if (vPosition.includes('%')) {
                    vPosition = vPosition.replace(/%/gim, "");
                    if (!isNaN(parseFloat(vPosition))) {
                      let pos = parseFloat(vPosition);

                      // Calculate threshold lines based on yPadding
                      // yPadding of 10% = ~1.9 lines from top/bottom (10% / 5.26%)
                      const paddingThreshold = yPadding; // Use percentage directly

                      // Check if position falls within padding zones
                      if (pos <= paddingThreshold) {
                        ccEvent.yPos = "start";
                      } else if (pos >= 100 - paddingThreshold) {
                        ccEvent.yPos = "end";
                      } else {
                        // Convert percentage to line position on display
                        let calculatedPos = 1 + Math.round(pos / 100 * fullDisplayHeight) - options.window.yPadding / 100 * fullDisplayHeight;
                        // console.log("VPosition Calculated: " + calculatedPos);

                        // Determine if it should be a flexbox value or line offset
                        if (calculatedPos >= displayHeight) {
                          ccEvent.yPos = "end";
                        } else if (calculatedPos <= 1) {
                          ccEvent.yPos = "start";
                        } else {
                          // console.log("Calculated Pos: " + calculatedPos);
                          ccEvent.yPos = Math.floor(calculatedPos);
                          if (ccEvent.yPos / displayHeight > 0.8) {
                            ccEvent.yPos = "end";
                          }
                        }
                      }
                    }
                  } else {
                    // Handle line numbers (integer values)
                    let lineNum = parseInt(vPosition);
                    if (!isNaN(lineNum)) {
                      // Calculate line threshold based on yPadding
                      // For 19 lines: each line = 5.26% of screen
                      // yPadding of 10% ≈ 1.9 lines, so < 3 = start, > 17 = end
                      const lineThreshold = Math.ceil(yPadding / 100 * 19);
                      if (lineNum >= 0) {
                        // Positive values: offset from top (1-19)
                        if (lineNum <= lineThreshold) {
                          ccEvent.yPos = "start";
                        } else if (lineNum >= 17 - lineThreshold) {
                          ccEvent.yPos = "end";
                        } else {
                          // Convert line number to percentage for display positioning
                          let linePercent = lineNum / 19 * 100;
                          let calculatedPos = Math.round(linePercent / 100 * displayHeight);
                          if (linePercent < 35) {
                            ccEvent.yPos = calculatedPos <= 1 ? "start" : Math.max(1, calculatedPos);
                          } else if (linePercent < 65) {
                            ccEvent.yPos = "center";
                          } else {
                            ccEvent.yPos = calculatedPos >= displayHeight - 1 ? "end" : Math.min(displayHeight, calculatedPos);
                          }
                        }
                      } else {
                        // Negative values: offset from bottom (-1 to -19)
                        // -1 is the bottom line, -19 is the top line
                        let positiveLineNum = 19 + lineNum + 1; // Convert to 1-19 scale

                        if (positiveLineNum <= lineThreshold) {
                          ccEvent.yPos = "start";
                        } else if (positiveLineNum >= 19 - lineThreshold) {
                          ccEvent.yPos = "end";
                        } else {
                          // Convert to percentage for display positioning
                          let linePercent = positiveLineNum / 19 * 100;
                          let calculatedPos = Math.round(linePercent / 100 * displayHeight);
                          if (linePercent < 35) {
                            ccEvent.yPos = calculatedPos <= 1 ? "start" : Math.max(1, calculatedPos);
                          } else if (linePercent < 65) {
                            ccEvent.yPos = "center";
                          } else {
                            ccEvent.yPos = calculatedPos >= displayHeight - 1 ? "end" : Math.min(displayHeight, calculatedPos);
                          }
                        }
                      }
                    }
                  }
                }
              });
            }
          } else if (tcFlag) {
            ccEvent.text += "\n" + blockLine;
          }
        });
      }
      if (tcFlag) {
        events.push(ccEvent);
      }
    });

    // console.log(JSON.stringify(events, null, 4));
    events.forEach(event => {
      // console.log("----------------");
      // console.log("Before:" + event.text);
      let longestLine = getLongestLine(event.text);
      event.text = vttFunc.replaceColorTags(event.text).replace(/<(?!\/?(em|i|strong|u|b|ruby|rt|white|yellow|green|black|red|blue|cyan|magenta)\b)[^>]+>/gi, "");
      // Convert native VTT ruby to internal form if present
      if (rubyMarkup.hasRuby(event.text) && !/data-align=/.test(event.text)) {
        event.text = event.text.replace(/<ruby>/gi, '<ruby data-align="center">');
      }
      // Parenthetical ruby from SRT-style VTT
      if (/\S+\([^)]+\)/.test(event.text) && !rubyMarkup.hasRuby(event.text)) {
        event.text = rubyMarkup.parentheticalToRuby(event.text);
      }
      event.text = convertToHtml(event.text);
      // console.log("After:" + event.text);
      // Check if xPos is a number
      if (typeof event.xPos === "number" && event.xPos - longestLine.length < 1) {
        //get length of the longest line in the Event Text:
        event.xPos = Math.max(1, displayWidth - longestLine.length);
      }
    });
    return events;
  },
  encode: function (eventGroup, options) {
    let encodingOptions = getFormatOptions(options.formatOptions),
      fontStyleCues = false,
      overrideFontColor = false,
      overrideBackgroundColor = false,
      htmlTags = false,
      encodeId = false,
      encodeSpeakerCues = false,
      encodeColor = false,
      encodeFormatting = false,
      fontColor = "white",
      backgroundColor = "black",
      maxLength = 32;
    if (encodingOptions["Encode Id"] && encodingOptions["Encode Id"] !== "false") {
      encodeId = encodingOptions["Encode Id"];
    }
    if (encodingOptions["Encode Speaker Cues"] && encodingOptions["Encode Speaker Cues"] !== "false") {
      encodeSpeakerCues = encodingOptions["Encode Speaker Cues"];
    }
    if (encodingOptions["Encode Color"] && encodingOptions["Encode Color"] !== "false") {
      encodeColor = encodingOptions["Encode Color"];
    }
    if (encodingOptions["Encode Formatting"] && encodingOptions["Encode Formatting"] !== "false") {
      encodeFormatting = encodingOptions["Encode Formatting"];
    }
    if (encodingOptions["Use HTML Tags"] && encodingOptions["Use HTML Tags"] !== "false") {
      htmlTags = encodingOptions["Use HTML Tags"];
    }
    if (encodingOptions["Override Font Color"] && encodingOptions["Override Font Color"] !== "false") {
      overrideFontColor = encodingOptions["Override Font Color"];
    }
    if (encodingOptions["Override Background Color"] && encodingOptions["Override Background Color"] !== "false") {
      overrideBackgroundColor = encodingOptions["Override Background Color"];
    }
    if (encodingOptions["Font Color"]) {
      fontColor = encodingOptions["Font Color"];
    }
    if (encodingOptions["Background Color"]) {
      backgroundColor = encodingOptions["Background Color"];
    }
    if (encodingOptions["Max Characters Per Line"]) {
      maxLength = encodingOptions["Max Characters Per Line"] || 32;
    }
    let output = "WEBVTT\n\n";
    if (encodingOptions["Encode Font Styles"] && encodingOptions["Encode Font Styles"] !== "false") {
      fontStyleCues = true;
      output += vttFunc.fontStyleCues + "\n\n";
    }
    if (encodingOptions["Encode Metadata Notes"] && encodingOptions["Metadata Notes"]) {
      output += "NOTE\n";
      output += encodingOptions["Metadata Notes"] + "\n\n";
    }
    eventGroup.events = eventGroup.events.filter(event => {
      return stripTags(event.text).trim() !== "";
    });
    eventGroup.events.forEach(function (event, eventIndex) {
      let eventText;
      let plainText = convertToPlainText(event.text);
      let numberOfLines = eol.split(plainText).length;
      if (encodeId) {
        output += `${eventIndex + 1}` + "\n";
      }

      // console.log(plainText);

      output += tcLib.secToTcMs(event.start, options.frameRate, options.dropFrame).replace(",", ".") + " --> " + tcLib.secToTcMs(event.end, options.frameRate, options.dropFrame).replace(",", ".");
      const encodeRuby = encodingOptions["Encode Ruby"] !== false && encodingOptions["Encode Ruby"] !== "false";
      const isVertical = event.writingMode === "tbrl";
      if (isVertical) {
        output += " vertical:rl";
      }
      if (encodingOptions["Encode Position"] && encodingOptions["Encode Position"] != "false") {
        let line = vttFunc.calcLineValue(event, numberOfLines, options.window);
        let size = vttFunc.calcSize(event, options.window);
        let position = vttFunc.calcPos(event, options.window, size);
        let vlcAlignment = vttFunc.alignmentMap[event.xPos] || "center";
        let vlcLineValue = vttFunc.calcVlcLineValue(event, numberOfLines, options.window);
        let alignment = event.alignment;

        /* WebCargo Code Start */
        // encodingOptions["Position Template"] = encodingOptions["Position Template"] || "Custom01";
        /* WebCargo Code End */
        switch (encodingOptions["Position Template"]) {
          case "YouTube":
            /* eg. line:50% align:middle size:35% | line = y position, align = x position (left, middle, right)*/
            output += ` line:${line.toFixed(2)}% align:${alignment} size:${size}%`;
            break;
          case "MUFI":
            /* eg. line:78% position:50% align:middle*/
            output += ` line:${line.toFixed(2)}% position:50% align:${alignment === "center" ? "middle" : alignment}`;
            break;
          case "VLC":
            /* Works for VLC and Switch */
            /* Line is the vertical line number, alignment is the alignment, and position is the movement over. NOTE: We decided to only support line and alignment because position does not work when alignment is set to center or right */
            /* 
                Line is a value from 1 to 20. 3 is the top caption line. 18 is the bottom caption line.
            */
            /*  */
            /* line:18 align:left position:0% */
            output += ` align:${vlcAlignment} line:${vlcLineValue}`;
            break;
          case "Ooona":
            output += ` line:${line}%`;
            break;
          case "Standard":
            /* Align - font alignment, Position - Horizontal offset, Line - Vertical Offset */
            output += ` align:${event.alignment} position:${position}% line:${line}%`;
            break;
          case "Custom01":
            line = vttFunc.webcargoLineValue(event, numberOfLines, options.window);
            output += " align:" + vlcAlignment + " line:" + line.toFixed(2) + "%";
            break;
          case "Custom02":
            //Discovery:
            output += ` align:${event.alignment} line:${line.toFixed(2)}%`;
            break;
          case "Custom03":
            //Line without %:
            output += ` align:${event.alignment} line:${event.yPos === "start" ? 0 : 0 - numberOfLines}`;
            break;
          case "Custom04":
            //Line without %:
            output += ` line:${event.yPos === "start" ? 0 : 0 - numberOfLines}`;
            break;
          default:
            //Discovery:
            //output += ` align:${event.alignment} line:${line.toFixed(2)}%`;
            //Real Default:
            // console.log("----=-----------------------");
            // console.log(event, position);
            output += ` align:${event.alignment} position:${position.toFixed(2)}% line:${line.toFixed(2)}% size:${size.toFixed(2)}%`;
        }
      }
      if (encodeFormatting) {
        //Only keep color span info when color is being encoded, otherwise strip the color spans.
        eventText = convertToPlainTextCustom(event.text, "\n", false, "b", "i", "u", encodeColor ? true : false);
        if (encodeColor) {
          eventText = vttFunc.convertHtmlToVttColors(eventText);
        }
      } else if (encodeColor) {
        eventText = vttFunc.convertHtmlToVttColors(convertToPlainTextCustom(event.text, "\n", false, "b", "i", "u", true));
      } else if (encodeFormatting) {
        eventText = convertToPlainTextCustom(event.text, "\n", false, "b", "i", "u");
      } else {
        eventText = convertToPlainTextCustom(event.text, "\n", true);
      }

      // Ruby: native HTML <ruby>/<rt> for WebVTT, or parenthetical / base-only
      if (rubyMarkup.hasRuby(event.text) || rubyMarkup.hasRuby(eventText)) {
        if (!encodeRuby) {
          eventText = rubyMarkup.rubyToBaseOnly(eventText);
        } else if (encodeFormatting || htmlTags) {
          eventText = rubyMarkup.rubyToWebVtt(convertToPlainTextCustom(event.text, "\n", false, "b", "i", "u", true));
        } else {
          eventText = rubyMarkup.rubyToParenthetical(convertToPlainTextCustom(event.text, "\n", false, "b", "i", "u")).replace(/<\/?[biu]>/gi, "");
        }
      }
      if (encodeSpeakerCues) {
        let evSpeaker = event.speakers && event.speakers.length > 0 ? event.speakers[0] : null;
        if (evSpeaker && evSpeaker.name) {
          let speakerTag = `<v ${evSpeaker.name}>`;
          eventText = speakerTag + eventText;
        }
      }
      eventText.split("\n").filter(lineText => {
        return lineText;
      }).forEach(line => {
        if (fontStyleCues && (overrideFontColor || overrideBackgroundColor)) {
          output += htmlTags ? "\n<font" : "\n<c";
          if (overrideFontColor) {
            output += htmlTags ? ` color="${fontColor}"` : "." + fontColor;
          }
          if (overrideBackgroundColor) {
            output += htmlTags ? ` background-color="${backgroundColor}"` : ".bg_" + backgroundColor;
          }
          output += ">" + line + (htmlTags ? "</font>" : "</c>");
        } else if (fontStyleCues && event.color !== "#FFFFFF" && vttFunc.colorMapping[event.color]) {
          output += "\n<c." + vttFunc.colorMapping[event.color] + ">";
          output += ">" + line + "</c>";
        } else {
          output += "\n" + line;
        }
      });
      output += "\n\n";
    });
    return output.trim();
  },
  preProcess: {
    encode: function (eventGroup) {
      /* All */
      return removeInvalidEvents(eventGroup);
    },
    decode: function (input) {
      let normalized = eol.lf(input).trim();

      /* If there are 3+ consecutive newlines, the file has extra blank lines.
         Strip all blank lines and re-insert a single blank line before each
         timecode line (-->) to reconstruct valid VTT cue blocks. */
      if (/\n{3,}/.test(normalized)) {
        let lines = normalized.split("\n").filter(line => line.trim() !== "");
        let result = [];
        lines.forEach(line => {
          if (line.includes(" --> ") && result.length > 0) {
            result.push("");
          }
          result.push(line);
        });
        return result.join("\n");
      }
      return normalized;
    }
  },
  postProcess: {
    encode: function (output) {
      return output.replace(new RegExp("(\n){3,}", "gim"), "\n\n");
    },
    decode: function (eventGroup, options) {
      // No post-processing needed for the new position system
      return eventGroup;
    }
  }
};